import { ReactNode } from 'react';
import type { DropdownProps } from 'antd';
import { Dropdown as AntDropdown } from 'antd';

import { Button } from '@components/Button';

interface Props extends DropdownProps {
  title: ReactNode;
}

const Dropdown = ({ title, ...otherProps }: Props): JSX.Element => {
  return (
    <AntDropdown {...otherProps}>
      <Button type='default'>{title}</Button>
    </AntDropdown>
  );
};

export default Dropdown;
